import React from "react";
import Toast from "./Toast";
import useToast from "@shared/hooks/useToast";
import './Toast.scss'


const ToastList = () => {
    const { toasts } = useToast()

    if (!!toasts) {
        return (
            <div
                className="toast-list"
            >
                {toasts.map((toast) => (
                    <Toast
                        key={`${toast.id}`}
                        message={toast.message}
                        id={toast.id}
                        color={toast.color}
                        timeOut={toast.timeOut}
                    />
                ))}
            </div>
        );
    }
};


export default ToastList;